import {CreateDistributionList} from "../../../common/distribution/createDistributionList";
import {DistributionsService} from "../../../../service/distributionList.service";
import {UserBasicService} from "../../../../service/users-basic.service";


export default function CreateDistributionListArauco() {
    const createDistributionList = async (name: string, selectedIds: string[]) => {
        await DistributionsService.create({
            name: name,
            organization: "arauco",
            usersBasic: selectedIds
        })
    };
    const getUsers = async () => {
        return await UserBasicService.findAll();
    };
    return(<CreateDistributionList onCreate={createDistributionList} onGetUsers={getUsers}/>)
}